import { defineStore } from 'pinia'
import { inject, markRaw, watch } from 'vue'
import { useI18n } from 'vue-i18n'

import { createH3liveRooms } from '../composables'

const useH3liveRoomsStore = defineStore('h3live-rooms', () => {
  const api = inject('api')
  if (!api) throw new Error('H3live rooms store: api provider is required')

  return { rooms: markRaw(createH3liveRooms(api)) }
})

/**
 * 每种界面语言只向服务端要一次房间列表；每个消费方拿到的都是同一份状态。
 * 在组件 setup 里调用：跟着界面语言走，切语言时按新语言重新取（直播间名是翻译过的）。
 */
export function useH3liveRooms() {
  const rooms = useH3liveRoomsStore().rooms
  const { locale } = useI18n()
  watch(locale, value => rooms.load(value), { immediate: true })
  return rooms
}
